module.exports = __webpack_public_path__ + "static/img/illegal.ddaaa5bb.png";